import React from "react";

import Input from "@mui/joy/Input";
import {CircularProgress, FormHelperText, Radio, RadioGroup, Stack,} from "@mui/joy";
import Grid from "@mui/joy/Grid";
import FormControl from "@mui/joy/FormControl";
import Button from "@mui/joy/Button";
import {DatePicker, DateTimePicker} from "@mui/x-date-pickers";
import 'dayjs/locale/ru';
import {
    CustomButtonSwitch,
    CustomDateWrapperField,
    CustomMultiSelectBoxesField,
    CustomMultiSelectField,
    CustomSelectField,
    InnerInput,
    KeyValuePairsField,
    NumberSliderField,
    SimpleTextarea,
    StringListField
} from "./FormFields";
import {CommonJSONField} from "./CommonJSONFieldForm";


class CommonForm extends React.Component {
    constructor(props) {
        super(props);
        this.form = React.createRef();
        this.state = {
            errors: null,
            processing: this.props.processing?this.props.processing:false,
            formData: null,
        }
    }

    generate_input(field) {
        let value = null;
        if (this.state.formData !== null){
            value = this.state.formData.get(field.name);
        }
        else if (this.props.object){
            value = this.props.object[field.name];
        }
        else if (field.default !== null) {
            value = field.default;
        }
        let label = field.label;
        if (field.required){
            label += ' *';
        }
        switch (field.type) {
            case 'component':
                return (
                    field.component
                )
            case 'submit':
                return(
                    <Stack
                        sx={{
                            mt: 1
                    }}
                        direction={'row'}
                        spacing={2}
                    >
                        <Button
                            variant={'soft'}
                            size={'md'}
                            type={'submit'}
                            color={field.color}
                            startDecorator={field.icon}
                            disabled={field.processing}
                        >
                            {field.label}
                        </Button>
                        {field.processing?<CircularProgress/>:null}
                    </Stack>
                )
            case 'select':
                return(
                    <CustomSelectField
                        disabled={field.processing}
                        size={field.size}
                        defaultValue={value}
                        options={field.options}
                        label={label}
                        required={field.required}
                        name={field.name}
                        empty={field.empty}
                        emptyLabel={field.emptyLabel}
                        emptyValue={field.emptyValue}
                        callBack={this.fieldCallBack.bind(this)}
                    />
                )
            case 'radio':
                return(
                    <RadioGroup
                        defaultValue={parseInt(value)}
                        name={field.name}
                        required={field.required}
                        disabled={field.processing}
                    >
                        {field.options.map(each => {
                            return(
                                <Radio
                                    size={field.size}
                                    value={each.value}
                                    label={each.label}
                                    variant="outlined"
                                />
                            )
                        })}
                    </RadioGroup>
                )
            case 'multiselect':
                return(
                    <CustomMultiSelectBoxesField
                        disabled={field.processing}
                        size={field.size}
                        defaultValue={value}
                        options={field.options}
                        label={label}
                        required={field.required}
                        name={field.name}
                        callBack={this.fieldCallBack.bind(this)}
                    />
                )
            case 'multiselect-inline':
                return(
                    <CustomMultiSelectField
                        disabled={field.processing}
                        size={field.size}
                        defaultValue={value}
                        options={field.options}
                        label={label}
                        required={field.required}
                        name={field.name}
                        callBack={this.fieldCallBack.bind(this)}
                    />
                )
            case 'date':
                return(
                    <CustomDateWrapperField
                        disablePast={field.disablePast}
                        size={field.size}
                        component={DatePicker}
                        label={label}
                        required={field.required}
                        defaultValue={value}
                        format={'YYYY-MM-DD'}
                        name={field.name}
                        disabled={field.processing}
                        callBack={this.fieldCallBack.bind(this)}
                    />
                )
            case 'datetime':
                return(
                    <CustomDateWrapperField
                        size={field.size}
                        component={DateTimePicker}
                        label={label}
                        required={field.required}
                        defaultValue={value}
                        format={'YYYY-MM-DD'}
                        name={field.name}
                        disabled={field.processing}
                        callBack={this.fieldCallBack.bind(this)}
                        disablePast={field.disablePast}
                    />
                )
            case 'checkbox':
                return(
                    <CustomButtonSwitch
                        disabled={field.processing}
                        size={field.size}
                        required={field.required}
                        name={field.name}
                        value={value}
                        label={label}
                        callBack={this.fieldCallBack.bind(this)}
                    />
                )
            case 'number':
                return(
                    <Input
                        slots={{ input: InnerInput }}
                        slotProps={{ input:
                            {
                                size: field.size,
                                label: label,
                                placeholder: '',
                                type: 'number',
                                required: field.required,
                                name: field.name,
                                defaultValue: value,
                                disabled: field.processing,
                            }
                        }}
                        sx={{
                            '--Input-minHeight': '56px',
                            '--Input-radius': '6px',
                        }}
                    />
                )
            case 'float':
                return(
                    <Input
                        slots={{ input: InnerInput }}
                        slotProps={{ input:
                            {
                                size: field.size,
                                label: label,
                                placeholder: '',
                                type: 'number',
                                step: 'any',
                                required: field.required,
                                name: field.name,
                                defaultValue: value,
                                disabled: field.processing,
                            }
                        }}
                        sx={{
                            '--Input-minHeight': '56px',
                            '--Input-radius': '6px',
                        }}
                    />
                )
            case 'numberSlider':
                return(
                    <NumberSliderField
                        disabled={field.processing}
                        size={field.size}
                        required={field.required}
                        name={field.name}
                        value={value}
                        label={label}
                        step={field.step}
                        min={field.min}
                        max={field.max}
                        callBack={this.fieldCallBack.bind(this)}
                    />
                )
            case 'textarea':
                return (
                    <SimpleTextarea
                        label={label}
                        size={field.size}
                        placeholder={label}
                        minRows={5}
                        required={field.required}
                        name={field.name}
                        defaultValue={value}
                        users={field.users}
                        disabled={field.processing}
                        callBack={this.fieldCallBack.bind(this)}
                    />
                )
            case 'simpleTextarea':
                return (
                    <SimpleTextarea
                        label={label}
                        size={field.size}
                        placeholder={label}
                        minRows={5}
                        required={field.required}
                        name={field.name}
                        defaultValue={value}
                        users={field.users}
                        disabled={field.processing}
                        callBack={this.fieldCallBack.bind(this)}
                    />
                )
            case 'stringList':
                return (
                    <StringListField
                        size={field.size}
                        label={label}
                        name={field.name}
                        defaultValue={value}
                        disabled={field.processing}
                        callBack={this.fieldCallBack.bind(this)}
                    />
                )
            case 'keyValuePairs':
                return (
                    <KeyValuePairsField
                        size={field.size}
                        label={label}
                        name={field.name}
                        defaultValue={value}
                        disabled={field.processing}
                        callBack={this.fieldCallBack.bind(this)}
                    />
                )
            case 'json':
                return (
                    <CommonJSONField
                        size={field.size}
                        label={label}
                        name={field.name}
                        defaultValue={value}
                        disabled={field.processing}
                    />
                )
            case 'input':
                return(
                    <Input
                        slots={{ input: InnerInput }}
                        slotProps={{ input:
                            {
                                size: field.size,
                                label: label,
                                placeholder: '',
                                type: 'text',
                                required: field.required,
                                name: field.name,
                                defaultValue: value,
                                disabled: field.processing,
                            }
                        }}
                        sx={{
                            '--Input-minHeight': '56px',
                            '--Input-radius': '6px',
                        }}
                    />
                )
            case 'password':
                return(
                    <Input
                        slots={{ input: InnerInput }}
                        slotProps={{ input:
                            {
                                label: label,
                                placeholder: '',
                                type: 'password',
                                required: field.required,
                                name: field.name,
                                defaultValue: value,
                            }
                        }}
                        sx={{
                            '--Input-minHeight': '56px',
                            '--Input-radius': '6px',
                        }}
                    />
                )
            case 'hidden':
                return ('')
            case 'file':
                return (
                    <Input
                        disabled={field.processing}
                        sx={{pt: 1}}
                        type={'file'}
                        required={field.required}
                        name={field.name}
                        defaultValue={value}
                        id={'form-'+field.name}
                        onChange={(event) => {
                            let maxSize = field.maxSize?field.maxSize:40
                            if(event.target.files[0].size > maxSize * 1024 * 1024) {
                                alert(`Размер файла должен быть менее ${maxSize}Мб`);
                                event.target.value = "";
                            }
                        }}
                    />
                )
            default:
                console.log(`Type of field ${field.type} is not supported.`);
            }
    }

    async processForm(event){
        event.preventDefault();
        let formData = new FormData(event.currentTarget);
        this.setState(
            {
                formData: formData,
                processing: true,
            }
        );
        let response = await this.props.processForm(
            {state: {formData: formData, formObject: event.currentTarget,}}
        )
        let errors
        if (response?.status > 299) {
            errors = response.data
        }
        this.setState({
            processing: false,
            errors: errors,
        });
    }

    fieldCallBack(){
        if (this.props.onChange) {
            this.props.onChange({target: {form: this.form.current}})
        }
    }

    render() {
        return(
            <form
                onSubmit={this.processForm.bind(this)}
                onChange={this.props.onChange}
                ref={this.form}
            >
                <Grid
                    container
                    spacing={2}
                    sx={{
                        flexGrow: 1,
                        alignItems: "flex-start",
                    }}
                >
                    {this.props.fields.map((field) => (
                        <Grid
                            xs={field.xs}
                            sm={field.sm}
                            md={field.md}
                            lg={field.lg}
                            xl={field.xl}
                            key={'grid-'+field.name}
                        >
                            <FormControl error={this.state.errors?!!this.state.errors[field.name]:false}>
                                {this.generate_input(
                                    ((field) => {field.size=this.props.size?this.props.size:null; field.processing=this.state.processing; return field})(field)
                                )}
                                <FormHelperText>
                                    {this.state.errors?this.state.errors[field.name]:null}
                                </FormHelperText>
                            </FormControl>
                        </Grid>
                    ))
                    }
                </Grid>
            </form>
        )
    }
}

export default CommonForm;